import React from "react";
import clsx from "clsx";

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  hint?: string;
  accent?: string; // tailwind border colour, e.g. "border-blue-500"
}

export const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  hint,
  accent = "border-blue-500",
}) => (
  <div className={clsx("card border-l-4 p-6", accent)}>
    <div className="mb-4 flex items-center justify-between">
      <div className="rounded-lg bg-slate-700/40 p-3">{icon}</div>
    </div>
    <p className="mb-1 text-sm text-slate-400">{label}</p>
    <p className="text-2xl font-bold text-slate-100">{value}</p>
    {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
  </div>
);
